import ProductsDetailOrder from "./ProductsDetailOrder";

export default ProductsDetailOrder;
